import React, { useState, useEffect } from 'react';
import { translate } from '../../Services/translation';
import { useDispatch } from 'react-redux';
import { updateIsStockNotify } from '../../Actions/ConfigStock.action';

const StockNotifyButton = ({ productId, addStockNotify, isStockNotify }) => {
  const dispatch = useDispatch(),
    [showStockNotify, setStockNotify] = useState(isStockNotify);

  useEffect(() => {
    setStockNotify(isStockNotify);
  }, [isStockNotify]);

  const handleStockNotify = (productId) => {
    const newStatus = !showStockNotify;
    dispatch(updateIsStockNotify(productId, newStatus));
    setStockNotify(newStatus);
    addStockNotify(productId);
  };

  return (
    <div>
      <a className='stock__subscribe' onClick={() => handleStockNotify(productId)} >
        {translate(showStockNotify ? 'product.stock.notify.subscribe' : 'product.stock.notify.notsubscribed')}
      </a>
    </div>
  );
};

export default StockNotifyButton;
